import * as api_gen from './General.ts';


interface Country {
    id: number;
    name: string;
    code: string;
}

interface Frequency {
    id: number;
    frequency: string;
}

interface PestRecord {
    id: number;
    common_name: string;
    scientific_name: string;
    eppo_code: string;
}

interface GetDashboardDataResponse {
    countries: Country[];
    years: number[];
    frequencies: Frequency[];
    moaCodes: string[];
    pestRecords: PestRecord[];
}


export async function getDashboardData(): Promise<GetDashboardDataResponse> {
    const url = "dashboard_data";

    const data = api_gen.getSimpleData(url);

    return data;
}


// ResisFreqData
// returns data like:
// {
//     "data": [
//         {
//             "country": "Netherlands",
//             "country_code": "NL",
//             "year": 2021,
//             "moa_code": "C2-7 -- Respiration - complex II: succinate-dehydrogenase",
//             "pest_scientific_name": "Alternaria solani",
//             "resistance_frequence": "Target-site resistance (TSR)"
//         },
//     ],
//     "countries": {
//         "Austria": "AT",
//         "Belgium": "BE",
//         "Sweden": "SE",
//         "United Kingdom": "GB"
//     },
//     "frac_moa": [
//         "C2-7 -- Respiration - complex II: succinate-dehydrogenase"
//     ],
//     "pest_sci_names": [
//         "Alternaria solani"
//     ],
//     "years": [
//         "2021",
//         "2020",
//         "2019"
//     ],
//     "frequencies": [
//         "Unknown",
//         "Target-site resistance (TSR)",
//         "Isolated cases",
//         "Variable",
//         "Low",
//         "Moderate",
//         "Undetectable"
//     ]
// }
export async function getResisFreqData(moa_code, pest_sci_name: string | null = null): Promise<GetResisFreqDataResponse> {
    const url = "resistance_frequency_data";

    let pest_sci_names: string[] | null = null;
    if (pest_sci_name != null) {
        pest_sci_names = [pest_sci_name];
    }

    const post_data = {
        "pest_sci_name": pest_sci_names,
        "moa_code": moa_code
    }


    const data = await api_gen.postSimple(url, post_data);

    return data;
}

export interface MonitoringDataItem {
    country: string;
    country_code: string;
    year: number;
    moa_code: string;
    pest_scientific_name: string;
    resistance_frequence: string;
}

export interface GetResisFreqDataResponse {
    data: MonitoringDataItem[];
    countries: { [key: string]: string };
    frac_moa: string[];
    pest_sci_names: string[];
    years: number[];
    frequencies: string[];
}
